export default __webpack_public_path__ + "static/media/Clutch of Black Terrors.05f31535.jpg";